const state = {
    onlineUserCount:0,//在线人数
    warnList:[],//报警数据
    riskAreaList:[],//风险区数据
}
const getters = {
    onlineUserCount:(state)=>{return state.onlineUserCount},//在场人员数量
    warnList:(state)=>{return state.warnList},//区域数量
    riskAreaList:(state)=>{return state.riskAreaList},//低风险区域数量
}
const mutations = {
    setOnlineUserCount:(state,count)=>{state.onlineUserCount=count},//在场人员数量
    setWarnList:(state,data)=>{state.warnList=data},//报警数据
    setRiskAreaList:(state,count)=>{state.riskAreaList=count},//风险区数据
}
const actions = {
    setOnlineUserCount: ({
        commit
    }, param) => {
        commit("setOnlineUserCount", param);
    },
    setWarnList: ({
        commit
    }, param) => {
        commit("setWarnList", param);
    },
    setRiskAreaList: ({
        commit
    }, param) => {
        commit("setRiskAreaList", param);
    },
}

export default {
state,
getters,
mutations,
actions
};
